import * as core from 'cw-ui-core';
import { connect } from 'react-redux';

const HasAppRoleAccess = props => {
    const hasAccess = () => {
        if (props.allow) {
            let allowAccess = false;
            for (let role of props.allow) {
                if(props.userAppRoles === undefined){ break; }
                //When there is only one role assigned, convert it to array. currently roles are coming as string instead of array in that case.
                const userAppRolesArray = Array.isArray(props.userAppRoles)
                    ? props.userAppRoles
                    : props.userAppRoles ? [props.userAppRoles] : [];
                allowAccess = userAppRolesArray.filter(appRole => appRole.appRoleId === role)?.length > 0;
                if (props.requireAll && !allowAccess) { break; }
                else if (!props.requireAll && allowAccess) { break; }
            }
            return allowAccess;
        }

        return false;
    };

    if (hasAccess()) {
        return props.children;
    }

    return props.fallback ? props.fallback : null;
};

const mapStateToProps = state => {
    const userStoreObject = core.getUser(state.oidc);
    const userAppRoles = userStoreObject.getIn(['profile', 'app_role_assignments']);
    let userAppRolesParsed;
    if (userAppRoles) {
        userAppRolesParsed = typeof userAppRoles === 'string' || userAppRoles instanceof String ? [userAppRoles] : userAppRoles.toJS();
    }
    //When there is only one role assigned, convert it to array. currently roles are coming as string instead of array in that case.
    userAppRolesParsed = Array.isArray(userAppRolesParsed)
            ? userAppRolesParsed
            : userAppRolesParsed
                ? [userAppRolesParsed]
                : [];

    return {
        userAppRoles: userAppRolesParsed ? userAppRolesParsed : [],
    };
};

export default connect(mapStateToProps)(HasAppRoleAccess);
